import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetJackpotHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_JACKPOT
            });

            if (data.status === 'success') {
                const jackpot = [...getState().usersMobile.list_jackpot.data];
                jackpot.push(data.data);
                dispatch(Action.SetGetJackpotHistoryListAction({
                    data: jackpot.flat(1),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetJackpotHistoryList as SetGetJackpotHistoryList
}